export const ID = 'SC50'
